import { getInteger, maxValue, unTriggeredRuleResult, validateLength } from '../utils';

/**
 * Rule that checks to see if the integer portion of the value exceeds the maximum
 * @param {ValidationRuleParameters}  params
 * @param {string | undefined}        value
 */
export const maxDecimalIntegerLengthRule = (params, value) => {
  if (typeof value !== 'string') {
    return unTriggeredRuleResult;
  }
  const validValueResponse = {
    triggered: false,
    validationState: {
      isValid: true,
      type: undefined,
      messageKey: 'exceedsMaxIntegerDecimalDigits'
    }
  };
  if (!params.allowDecimal) {
    return validValueResponse;
  }
  const integerDigits = getInteger(value);
  const max = maxValue(params.masking, params.maxLength);
  const results = validateLength(integerDigits, max, 'greaterThan');
  return {
    triggered: results,
    validationState: {
      isValid: !results,
      message: results ? params.customErrorMessages?.exceedsMaxIntegerDecimalDigits || `'${value}' exceeds integer character limit of ${max}` : undefined,
      type: 'error',
      messageKey: 'exceedsMaxIntegerDecimalDigits'
    }
  };
};